import { MaterialComponentCategory, MaterialComponentInputValue, type MaterialComponentValue } from 'api';

import { type MaterialComponentValueType } from '../../schema';

export const convertFromMaterialComponentValue = (
  materialSupportedComponent: MaterialComponentValue[],
  category?: MaterialComponentCategory
): MaterialComponentValueType[] => {
  const filteredMaterialSupportedComponent = category
    ? materialSupportedComponent.filter(
        (materialSupportedComponent) => materialSupportedComponent.supported_component.component.category === category
      )
    : materialSupportedComponent;

  return filteredMaterialSupportedComponent.map((materialSupportedComponent) => ({
    allowed_value_type: materialSupportedComponent.supported_component.allowed_value_type,
    boolean_value: materialSupportedComponent.boolean_value ?? undefined,
    max_value: materialSupportedComponent.max_value ? Number(materialSupportedComponent.max_value) : undefined,
    min_value: materialSupportedComponent.min_value ? Number(materialSupportedComponent.min_value) : undefined,
    supported_component_id: materialSupportedComponent.supported_component.id,
    unit: materialSupportedComponent.supported_component.component.unit,
  }));
};

export const convertToMaterialComponentInput = (
  materialSupportedComponent: MaterialComponentValueType[]
): MaterialComponentInputValue[] => {
  return materialSupportedComponent.map((materialSupportedComponent) => ({
    boolean_value: materialSupportedComponent.boolean_value ?? undefined,
    max_value: materialSupportedComponent.max_value ? materialSupportedComponent.max_value.toString() : undefined,
    min_value: materialSupportedComponent.min_value ? materialSupportedComponent.min_value.toString() : undefined,
    supported_component_id: materialSupportedComponent.supported_component_id,
  }));
};
